var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        {
          attrs: { "right-fixed": "" },
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: { click: _vm.onSave },
                    },
                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(_vm._s(_vm.$t("billingPage.BillingRegularSurcharge")) + " ")]
      ),
      _c(
        "el-form",
        {
          ref: "saveForm",
          staticClass: "bj-query-form bj-query-form-for-cal-height",
          attrs: { size: "mini", model: _vm.queryParams, rules: _vm.rules },
        },
        [
          _c(
            "el-row",
            { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.userName"),
                        prop: "clientCode",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.clientCodeList,
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.queryParams.clientCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "clientCode", $$v)
                          },
                          expression: "queryParams.clientCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.BillingCategories"),
                        prop: "billCategoryCode",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.billCategoryCodeList,
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.queryParams.billCategoryCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "billCategoryCode", $$v)
                          },
                          expression: "queryParams.billCategoryCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.BasedSource"),
                        prop: "basedSource",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.basedSourceList,
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.queryParams.basedSource,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "basedSource", $$v)
                          },
                          expression: "queryParams.basedSource",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.Date"),
                        prop: "queryParamsTime",
                      },
                    },
                    [
                      _c("BjDateRangePicker", {
                        attrs: { placeholder: _vm.$t("billingPage.Date") },
                        model: {
                          value: _vm.queryParamsTime,
                          callback: function ($$v) {
                            _vm.queryParamsTime = $$v
                          },
                          expression: "queryParamsTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.ChargeValue"),
                        prop: "chargeValue",
                      },
                    },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.queryParams.chargeValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "chargeValue", $$v)
                          },
                          expression: "queryParams.chargeValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.CoverageRate"),
                        prop: "chargeRate",
                      },
                    },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          min: 0,
                          max: 100,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.queryParams.chargeRate,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "chargeRate", _vm._n($$v))
                          },
                          expression: "queryParams.chargeRate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.state"),
                        prop: "state",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.ORDER_ACTIVE_TYPE,
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.queryParams.state,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "state", $$v)
                          },
                          expression: "queryParams.state",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.Coments"),
                        prop: "description",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          type: "textarea",
                          "show-word-limit": "",
                          autosize: "",
                          maxlength: _vm.MAX_LENGTH.BILLMAX,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.queryParams.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "description", $$v)
                          },
                          expression: "queryParams.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", { attrs: { "right-fixed": "" } }, [
        _vm._v(_vm._s(_vm.$t("billingPage.RegularRules"))),
      ]),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: false,
          "right-toolbar-hide": true,
          "search-btn-hide": true,
        },
        on: {
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    col.prop == "clientCode"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#3173d0" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.clientCode)
                                              ),
                                            ]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row.clientCode,
                                            },
                                          }),
                                        ]
                                      : col.prop == "chargeRate"
                                      ? [
                                          _vm._v(
                                            _vm._s(scope.row.chargeRate) + " %"
                                          ),
                                        ]
                                      : col.prop == "state"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  scope.row.state == "ACTIVE"
                                                    ? "success"
                                                    : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.state == "ACTIVE"
                                                      ? _vm.$t(
                                                          "billingPage.ACTIVE"
                                                        )
                                                      : _vm.$t(
                                                          "billingPage.UNACTIVE"
                                                        )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-btn",
                                        attrs: {
                                          type: "text",
                                          disabled: scope.row.state == "ACTIVE",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDel(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("billingPage.EditSurcharge"),
            visible: _vm.dialogFormVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              staticClass: "bj-query-form bj-query-form-for-cal-height",
              attrs: { size: "mini" },
            },
            [
              _c(
                "el-row",
                { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpanS } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("billingPage.userName") } },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              disabled: "",
                              "option-list": _vm.clientCodeList,
                              placeholder: _vm.$t("chooseText"),
                            },
                            model: {
                              value: _vm.form.clientCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "clientCode", $$v)
                              },
                              expression: "form.clientCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpanS } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("billingPage.BillingCategories"),
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              disabled: "",
                              "option-list": _vm.billCategoryCodeList,
                              placeholder: _vm.$t("chooseText"),
                            },
                            model: {
                              value: _vm.form.billCategoryCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "billCategoryCode", $$v)
                              },
                              expression: "form.billCategoryCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpanS } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("billingPage.BasedSource") } },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              disabled: "",
                              "lov-code": "BILL_REGULAR_SURCHARGE_SOURCE",
                              placeholder: _vm.$t("chooseText"),
                            },
                            model: {
                              value: _vm.form.basedSource,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "basedSource", $$v)
                              },
                              expression: "form.basedSource",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpanS } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("billingPage.ChargeValue") } },
                        [
                          _c("BjInputMoney", {
                            attrs: {
                              placeholder: _vm.$t("inputText"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.chargeValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "chargeValue", $$v)
                              },
                              expression: "form.chargeValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpanS } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("billingPage.CoverageRate") },
                        },
                        [
                          _c("BjInputMoney", {
                            attrs: {
                              min: 0,
                              max: 100,
                              placeholder: _vm.$t("inputText"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.chargeRate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "chargeRate", _vm._n($$v))
                              },
                              expression: "form.chargeRate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpanS } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("billingPage.state") } },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.ORDER_ACTIVE_TYPE,
                              placeholder: _vm.$t("chooseText"),
                            },
                            model: {
                              value: _vm.form.state,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "state", $$v)
                              },
                              expression: "form.state",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpanS * 2 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("billingPage.Coments") } },
                        [
                          _c("BjInput", {
                            attrs: {
                              type: "textarea",
                              autosize: "",
                              "show-word-limit": "",
                              maxlength: _vm.MAX_LENGTH.BILLMAX,
                              placeholder: _vm.$t("inputText"),
                            },
                            model: {
                              value: _vm.form.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "description", $$v)
                              },
                              expression: "form.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveAmount()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }